import React from 'react';
import { Control } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { PaymentInfoForm } from '@/modules/partner/model/form';
import { TextField } from '@src-common/view/adapters/reactHookForm/TextField';

type Props = {
  control: Control<PaymentInfoForm>;
};

const GbPaymentInfo: React.FC<Props> = ({ control }) => {
  const intl = useIntl();

  return (
    <>
      <TextField
        name="accountNumber"
        title={intl.formatMessage({
          defaultMessage: 'ACCOUNT NUMBER',
          id: 'n8n0/+',
          description: 'Account number field title',
        })}
        placeholder={intl.formatMessage({
          defaultMessage: '00000000',
          id: 'mPjzkt',
          description: 'Account number field placeholder',
        })}
        rules={{
          pattern: {
            value: /^\d{6,8}$/,
            message: intl.formatMessage({
              defaultMessage: 'This is between 6 and 8 digits.',
              id: 'nJIDyD',
              description: 'Account number field error message',
            }),
          },
        }}
        description={intl.formatMessage({
          defaultMessage: 'This is between 6 and 8 digits.',
          id: 'ZmNueo',
          description: 'Account number field description',
        })}
        control={control}
      />
      <TextField
        name="sortCode"
        title={intl.formatMessage({
          defaultMessage: 'SORT CODE',
          id: '2HtcXD',
          description: 'Sort code field title',
        })}
        placeholder={intl.formatMessage({
          defaultMessage: '123456',
          id: '6yRuXM',
          description: 'Sort code field placeholder',
        })}
        rules={{
          pattern: {
            value: /^\d{6}$/,
            message: intl.formatMessage({
              defaultMessage: 'This is 6 digits.',
              id: 'IQpLQz',
              description: 'Sort code field error message',
            }),
          },
        }}
        control={control}
      />
    </>
  );
};

export { GbPaymentInfo };
